export const profile = {
    page_title: 'โปรไฟล์',
    have_point: 'คุณมีพอยท์',
    edit_profile_btn: 'แก้ไขโปรไฟล์',
    unsubscribe: 'ยกเลิกการเป็นสมาชิก',
    text_unsubscribe: 'ระบบจะทำการลบข้อมูลทั้งหมดและคะแนนสะสม<br/>จะถูกลบออกอย่างถาวร',
    unsubscribe_modal: {
        title: 'การยกเลิกสมาชิก',
        msg: 'คุณยืนยันที่จะยกเลิกการเป็นสมาชิก',
        msg_success: 'ยกเลิกการเป็นสมาชิกเรียบร้อยแล้ว',
        btn_confirm: 'ยืนยัน',
        btn_close: 'ปิด',
    },
    user_consent: 'ตั้งค่าความเป็นส่วนตัว',
    menu: {
        privacy: 'นโยบายความเป็นส่วนตัว',
        term: 'เงื่อนไขการใช้สิทธิพิเศษ',
        marketing: 'ช่องทางการรับข้อมูลข่าวสาร',
        raq_copy: 'ขอรับสำเนาข้อมูลส่วนบุคคล',
        send_copy: 'ส่งสำเนาข้อมูลส่วนบุคคลให้<br/>ผู้ควบคุมข้อมูลอื่น',
        text_contact: 'Other request please contact',
        contact_number: ' 02-252-2979'
    },

    copy_personal_modal: {
        title_topbar: 'ขอรับสำเนาข้อมูลส่วนบุคคล',
        firstname: 'ชื่อ',
        lastname: 'นามสกุล',
        birthdate: 'วันเกิด',
        contact_number: 'เบอร์โทรศัพท์',
        age: 'อายุ',
        consent_age: 'ฉันมีอายุเกิน 20 ปีบริบูรณ์',
        title_email: 'กรอกอีเมลสำหรับรับข้อมูล',
        email: {
            name: '',
            placeholder: 'e.g. hello@email.com',
            required: '',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        pin: 'กำหนดรหัสผ่านในการเปิดไฟล์',
        btn: 'ยืนยัน'
    },

    alert_title: 'ดำเนินการสำเร็จ',
    alert_msg: 'ทำรายการข้อมูลส่วนบุคคลสำเร็จ<br/>ระบบได้จัดส่งข้อมูลส่วนบุคคล<br/>ไปยังอีเมลเรียบร้อยแล้ว',
    alert_btn: 'ยืนยัน',
}

export const edit_profile = {
    page_title: 'แก้ไขโปรไฟล์',
    title: {
        label: 'คำนำหน้าชื่อ',
        required: 'กรุณาเลือกคำนำหน้าชื่อ',
        mr:{
            label:'นาย',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        mrs: {
            label:'นาง',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        miss: {
            label:'นางสาว',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        }
    },
    gender: {
        label: 'เพศ',
        required: 'กรุณาเลือกเพศ',
        male: {
            label:'ชาย',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        female: {
            label:'หญิง',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        other: {
            label:'อื่นๆ',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        }
    },
    firstname: {
        name: 'ชื่อ',
        placeholder: 'กรอกชื่อ',
        required: 'กรุณากรอกชื่อ',
        too_short: '',
        invalid: ''
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: 'กรอกนามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: '',
        invalid: ''
    },
    birthdate: {
        name: 'วันเกิด',
        placeholder: '',
        required: 'กรุณาเลือกวันเกิด',
        too_short: '',
        invalid: 'รูปแบบวันเกิดไม่ถูกต้อง',
        date: {
            name: '',
            defaultText: 'วัน',
            required: 'กรุณาเลือกวันเกิด'
        },
        month: {
            name: '',
            defaultText: 'เดือน',
            required: 'กรุณาเลือกวันเกิด'
        },
        year: {
            name: '',
            defaultText: 'ปี',
            required: 'กรุณาเลือกวันเกิด'
        },
    },
    contact_number: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'กรอกเบอร์โทรศัพท์',
        required: '',
        too_short: '',
        invalid: '',
    },
    email: {
        name: 'อีเมล',
        placeholder: 'กรอกอีเมล',
        required: '',
        too_short: '',
        invalid: 'อีเมลไม่ถูกต้อง',
    },
    address: {
        headline: 'ที่อยู่ในการจัดส่ง',

        address: {
            name: 'ที่อยู่',
            placeholder: 'กรอกที่อยู่',
            required: 'กรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: '',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง/ตำบล',
            placeholder: 'เลือกแขวง/ตำบล',
            required: '',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'เขต/อำเภอ',
            placeholder: 'เลือกเขต/อำเภอ',
            required: '',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'เลือกจังหวัด',
            required: '',
            too_short: '',
            invalid: '',
        },
    },

    dateDisableInput: {
        name: '',
        placeholder: '',
        required: '',
        too_short: '',
        invalid: '',
    },

    save_btn: 'บันทึก',
    btn_confirm: 'ตกลง',
    update_success: 'บันทึกสำเร็จ'
}
